// GetCountryPopup returns the information if for the current user a Country Popup (redirect)
// should be shown.
export const CountryDetectionService_GetCountryPopupLazy = () =>
  import("./service.grpc").then(
    (m) => m.CountryDetectionService_GetCountryPopup
  );
CountryDetectionService_GetCountryPopupLazy.method =
  "aysa_api.services.country_detection.v1.CountryDetectionService/GetCountryPopup" as const;

// GetCountrySwitch returns the countries where AY is available
// Used for the country switch in the header of the website
export const CountryDetectionService_GetCountrySwitchLazy = () =>
  import("./service.grpc").then(
    (m) => m.CountryDetectionService_GetCountrySwitch
  );
CountryDetectionService_GetCountrySwitchLazy.method =
  "aysa_api.services.country_detection.v1.CountryDetectionService/GetCountrySwitch" as const;
